import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import { createContentPage, checkIdentifier, updateContentPage } from '../services/api';
import { useNavigate } from "react-router-dom";

export const CreateContact = ({ closeModal }) => {
  // State to handle form fields, form submission status, and response messages
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [qrCodeImage, setQrCodeImage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    if (formSubmitted) {
      window.location.reload(); // Reload the page only if form submission was successful
    } else {
      closeModal(); // Just close the modal if the form was not submitted
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setSuccessMessage("");

    if (!title || !email || !subject) {
      setErrorMessage("Please fill in all fields.");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrorMessage("Please enter a valid email.");
      return;
    }
    setLoading(true);

    try {
      const data = await createContentPage(title,email,subject);
      console.log('data',data);
        if(data.msg){
          navigate("/pricing");
        }
        setFormSubmitted(true);
        setSuccessMessage("Your Contact QR Code generated successfully!");
        setQrCodeImage(data.qr_code_url);
    } catch (error) {
      setErrorMessage("There was an error submitting the form. Please try again.");
    }  finally {
      setLoading(false); // Reset loading state after API call is done
    }
  };

  const handleDownloadImage = () => {
    const downloadUrl = `https://urqr.urqr.pro/download-image?image_url=${encodeURIComponent(qrCodeImage)}`;
    window.open(downloadUrl, '_blank');
  };

  return (
    <Modal show onHide={handleClose} centered size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Create Contact Page</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

        {formSubmitted ? (
          <div className="text-center">
            <div className="d-flex justify-content-center align-items-center mb-3">
              <h4 className="mt-3 text-success ml-3">{successMessage}</h4>
            </div>
            {qrCodeImage && (
              <div className="mb-3">
                <img src={qrCodeImage} alt="Generated QR Code" className="img-fluid" />
              </div>
            )}
            <Button variant="success" onClick={handleDownloadImage} className="w-100">
              Download QR Code
            </Button>
          </div>
        ) : (
          <>
          <p>Create your Contact QR Code to share a secure 'Contact Us' page, allowing others to send messages without revealing your contact details.</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="title" className="mb-3">
              <Form.Label>Title *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="subject" className="mb-3">
              <Form.Label>Subject *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </Form.Group>

            <Button variant="success" type="submit" className="w-100" disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Submit"
              )}
            </Button>
          </Form>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const CreateClub = ({ closeModal, createdLink, createdCount, editData = null, isEditing = false }) => {
  // State to handle form fields, form submission status, and response messages
  console.log('editData',editData);
  
  const [title, setTitle] = useState(editData?.title || createdLink?.title || "");
  const [email, setEmail] = useState(editData?.email || createdLink?.email || "");
  const [identifier, setidentifier] = useState(editData?.identifier || (createdCount ? `QR ${createdCount + 1}` : 'QR 1'));
  const [subject, setSubject] = useState(editData?.description || createdLink?.description || "");
  const [label, setLabel] = useState(editData?.label || createdLink?.label || "");
  const [number, setNumber] = useState(editData?.number || createdLink?.number || createdCount + 1);
  const [keyStatus, setKeyStatus] = useState(editData?.keyStatus || 0);

  const [switchOn, setSwitchOn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [qrCodeImage, setQrCodeImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(editData?.image || "");

  const navigate = useNavigate();

  const handleSwitchToggle = () => {
    setSwitchOn(!switchOn);
    if (switchOn) {
      setLabel("");
      setNumber("");
    }
  };

  useEffect(() => {
    if (editData) {
      setKeyStatus(editData.key_status === 1 ? 1 : 0);
    }
  }, [editData]);

  const handleKeySwitchToggle = (e) => {
    setKeyStatus(e.target.checked ? 1 : 0); // Set status based on switch state
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalLabel = switchOn ? label : "";
    const finalNumber = switchOn ? number : "";

    setErrorMessage("");
    setSuccessMessage("");
    setLoading(true);

    if (!title || !email || !subject || !identifier) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrorMessage("Please enter a valid email.");
      return;
    }

    try {
      if (!isEditing) {
        const exists = await checkIdentifier({identifier,title});
        if (exists) {
          console.log('asda', editData?.identifier);
          
          setError(`Identifier "${identifier}" already exists.`);
          setLoading(false);
          return;
        }
      }
  
      let data;
      if (isEditing) {
        data = await updateContentPage({
          id: editData.id, // make sure editData includes ID
          title,
          email,
          subject,
          identifier,
          label: finalLabel,
          number: finalNumber,
          keyStatus,
          imageFile
        });
      } else {
        data = await createContentPage(title,email,subject,identifier,finalLabel,finalNumber, keyStatus, imageFile);
      }
  
      if (data.msg) {
        navigate("/pricing");
      }
  
      setFormSubmitted(true);
      setSuccessMessage(isEditing ? "Updated successfully!" : "Your QR Code generated successfully!");
      setQrCodeImage(data.qr_code_url);
    } catch (error) {
      setErrorMessage("There was an error submitting the form. Please try again.");
    } finally {
      setLoading(false);
    }


  };

  useEffect(() => {
    if (editData?.image) {
      setImagePreview(editData.image);
    }
  }, [editData]);

  const handleClose = () => {
    if (formSubmitted) {
      window.location.reload(); // Reload the page only if form submission was successful
    } else {
      closeModal(); // Just close the modal if the form was not submitted
    }
  };

  const validateIdentifier = async () => {
    setLoading(true);
    setError('');
    if (title.trim() === '') {
      return;
    }
    if (identifier.trim() === '') {
      setLoading(false);
      setError('Identifier cannot be empty.');
      return;
    }
    try {
      const exists = await checkIdentifier({identifier,title});
      if (exists) {
        if(editData?.identifier != identifier){
          setError(`Identifier "${identifier}" already exists.`);
          setLoading(true);
        }else{
          setError('');
          setLoading(false);
        }
      } else {
        setError('');
        setLoading(false);
      }
    } catch (error) {
      console.error("Error checking identifier:", error);
      setError("An error occurred while validating. Please try again.");
      setLoading(true);
    }
  };

  useEffect(() => {
    validateIdentifier();
  }, [identifier]);

  const handleDownloadImage = () => {
    const downloadUrl = `https://urqr.urqr.pro/download-image?image_url=${encodeURIComponent(qrCodeImage)}`;
    window.open(downloadUrl, '_blank');
  };

  return (
    <Modal show onHide={handleClose} centered size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
      {!editData ? (
        <Modal.Title>Create Club Page</Modal.Title>
      ):(
        <Modal.Title>Update Club Page</Modal.Title>
      )}
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

        {formSubmitted ? (
          <div className="text-center">
            <div className="d-flex justify-content-center align-items-center mb-3">
              <h4 className="mt-3 text-success ml-3">{successMessage}</h4>
            </div>
            {qrCodeImage && (
              <div className="mb-3">
                <img src={qrCodeImage} alt="Generated QR Code" className="img-fluid" />
              </div>
            )}
            {!editData && (
            <Button variant="success" onClick={handleDownloadImage} className="w-100">
              Download QR Code
            </Button>
            )}
          </div>
        ) : (
          <>
          {!editData ? (
              <p>Create your Contact QR Code to share a secure 'Contact Us' page, allowing others to send messages without revealing your contact details.</p>
            ):(
              <p>Update your Contact QR Code details below. You can modify the content of your secure 'Contact Us' page while keeping your privacy intact.</p>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="title" className="mb-3">
              <Form.Label>Club Title *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Club Name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="identifier" className="mb-3">
              <Form.Label>Private Identifier *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Private Identifier"
                value={identifier}
                onChange={(e) => setidentifier(e.target.value)}
                isInvalid={!!error}
                required
              />
              {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
            </Form.Group>

            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="subject" className="mb-3">
              <Form.Label>Subject *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </Form.Group>

            {/* Switch Button */}
            <Form.Group controlId="switchControl" className="mb-3">
            <Form.Label>Key Status</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Label className="me-2">OUT</Form.Label>
                <Form.Check
                  type="switch"
                  checked={keyStatus === 1}
                  onChange={handleKeySwitchToggle}
                  style={{ marginLeft: "10px", paddingTop: "5px", borderBottom: "none" }}
                />
                <span style={{ marginLeft: "15px", marginTop: "-7px" }}>IN</span>
              </div>
            </Form.Group>            

            <Form.Group controlId="imageUpload" className="mb-3">
            <Form.Label>Upload or Capture Image</Form.Label>
            <div>
              <label htmlFor="fileInput" className="btn btn-outline-primary">
                Choose Image
              </label>
              <Form.Control
                id="fileInput"
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setImageFile(file);
                    setImagePreview(URL.createObjectURL(file));
                  }
                }}
              />
            </div>
          </Form.Group>

          {imagePreview && (
            <div className="mb-3 text-center">
              <img
                src={imagePreview}
                alt="Preview"
                className="img-fluid rounded"
                style={{ maxHeight: "200px" }}
              />
            </div>
          )}
          
            {!editData && (
              <>
                {/* Switch Button */}
                <Form.Group controlId="switchControl" className="mb-3">
                  <Form.Label>QR above & below content</Form.Label>
                  <Form.Check
                    type="switch"
                    checked={switchOn}
                    onChange={handleSwitchToggle}
                  />
                </Form.Group>

                {/* Conditional Fields */}
                <div className="d-flex mb-3">
                  <Form.Group controlId="label" className="me-3 flex-fill">
                    <Form.Label>Above Label (optional)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Label"
                      value={label}
                      onChange={(e) => setLabel(e.target.value)}
                      disabled={!switchOn}
                    />
                  </Form.Group>

                  <Form.Group controlId="number" className="flex-fill">
                    <Form.Label>Below Number</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Number"
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                      readOnly
                    />
                  </Form.Group>
                </div>
              </>
            )}

            {/* <Button variant="success" type="submit" className="w-100" disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Submit"
              )}
            </Button> */}
            <Button variant="success" type="submit" className="w-100" disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                isEditing ? "Update" : "Submit"
              )}
            </Button>
          </Form>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const PageOne = ({ closeModal }) => (
  <Modal show onHide={closeModal} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>Page One</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h2>Page One</h2>
      <p>Details for Page One QR Code creation.</p>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-secondary" onClick={closeModal}>
        Close
      </button>
    </Modal.Footer>
  </Modal>
);

export const PageTwo = ({ closeModal }) => (
  <Modal show onHide={closeModal} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>Page Two</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h2>Page Two</h2>
      <p>Details for Page Two QR Code creation.</p>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-secondary" onClick={closeModal}>
        Close
      </button>
    </Modal.Footer>
  </Modal>
);

export const PageThree = ({ closeModal }) => (
    <Modal show onHide={closeModal} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Page Three</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h2>Page Three</h2>
        <p>Details for Page Three QR Code creation.</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={closeModal}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
